import { CheckStatus } from 'dashboard/models/check';
import { CheckName } from 'lib/verificationCheck';

// Represents statuses specified as status stubs
export enum SandboxForcedStatus {
  Passed = 'passed',
  Failed = 'failed',
}

// Omitting passed status since CheckStub and MatchRequirementStub are used to configure checks/match requirements that should fail
export interface CheckStub {
  name: CheckName;
  status: Omit<CheckStatus, 'passed'>;
  reasons: string[];
}

export interface MatchRequirementStub {
  name: string;
  status: Omit<CheckStatus, 'passed'>;
}

export interface MatchRequirementsCheckStub {
  name: CheckName;
  'match-requirement-stubs': MatchRequirementStub[];
}

export type VerificationStubs =
  | {
      'check-stubs': (CheckStub | MatchRequirementsCheckStub)[];
    }
  | {
      'status-stub': SandboxForcedStatus;
    };

export interface GovernmentIdExtractions {
  birthdate?: string;
  'identification-number'?: string;
  'id-class'?: string;
  'name-first'?: string;
  'name-last'?: string;
  'address-street-1'?: string;
  'address-city'?: string;
  'address-subdivision'?: string;
  'address-postal-code'?: string;
  'issuing-authority'?: string;
  'issuing-subdivision'?: string;
  'country-code'?: string;
  sex?: string;
  'issue-date'?: string;
  'expiration-date'?: string;
}

export interface GovernmentIdVerificationProcessStubs {
  'verification-stubs': VerificationStubs;
  'document-stubs': {
    kind: 'government_id';
    extractions: GovernmentIdExtractions;
  };
}

export interface GenericVerificationProcessStubs {
  'verification-stubs': VerificationStubs;
}

export interface GovernmentIdVerificationTemplateVersionStubs
  extends GovernmentIdVerificationProcessStubs {
  id: string;
}

export interface GenericVerificationTemplateVersionStubs extends GenericVerificationProcessStubs {
  id: string;
}

export type VerificationTemplateVersionStubs =
  | GenericVerificationTemplateVersionStubs
  | GovernmentIdVerificationTemplateVersionStubs;
